import Cookies from 'js-cookie';
$( () => {
  let notificationTopBar = $( '.notification-top-bar' );
  let notificationDescription = $.trim( $( '.notification-top-bar__description' ).text() );
  let notificationTopBarLink = $.trim( $( '.notification-top-bar__link' ).attr( 'href' ) );
  let notificationTopBarLinkLabel = $.trim( $( '.notification-top-bar__link' ).text() );
  let notificationBarCloseBtn = $( '#notification-top-bar__close' );
  let notificationTopBarHideDuration = notificationTopBar.data( 'duration' );
  const setCookie = ( name, value, options ) => {
    Cookies.set( name, value, options );
  };

  notificationBarCloseBtn.on( 'click', function () {
    let expireDuration = new Date(
      new Date().getTime() +
      ( parseInt( notificationTopBarHideDuration ) * 60 ) * 60 * 1000
    );
    setCookie( 'hideAnzerNotification', '1', {
      expires: expireDuration,
    } );
    
    setCookie( 'notificationDescription', notificationDescription, {
      expires: expireDuration,
    } );
    
    setCookie( 'notificationTopBarLink', notificationTopBarLink, {
      expires: expireDuration,
    } );
    
    setCookie( 'notificationTopBarLinkLabel', notificationTopBarLinkLabel, {
      expires: expireDuration,
    } );
    notificationTopBar.hide();
  
  } );
} );
